import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import axiosService from "../utils/axios";
import { store } from "../store/store";
import { setAuthTokens, setAccount, setSessionInitialized } from "../store/slices/authSlice";
import { fetchAllObjects } from "../store/storeFunc";
import { fetchEnrollments } from "./UserManagement/UserActions";


/**
 * On app load: if access token + account are missing, try POST /auth/refresh/ (HttpOnly cookie)
 * then GET /users/me/ so F5 keeps the user logged in.
 */
function AuthSessionRestore({ children }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;

        const loadProfile = async (access) => {
            dispatch(setAuthTokens({ token: access }));
            const meRes = await axiosService.get("/users/me/");
            if (cancelled) return;
            dispatch(setAccount(meRes.data));
            if (meRes.data.is_staff) {
                fetchEnrollments(dispatch, navigate);
            }
            fetchAllObjects(dispatch);
        };

        const finish = () => {
            if (!cancelled) {
                dispatch(setSessionInitialized(true));
            }
        };

        (async () => {
            const { token, account } = store.getState().auth;
            if (token && account) {
                finish();
                return;
            }

            try {
                let access = token;
                if (!access) {
                    const res = await axios.post(`auth/refresh/`, {}, { withCredentials: true });
                    if (cancelled) return;
                    access = res.data.access;
                }
                await loadProfile(access);
            } catch {
                if (token) {
                    try {
                        const res = await axios.post(`auth/refresh/`, {}, { withCredentials: true });
                        if (cancelled) return;
                        await loadProfile(res.data.access);
                    } catch {
                        dispatch(setAuthTokens({ token: null }));
                    }
                } else {
                    dispatch(setAuthTokens({ token: null }));
                }
            } finally {
                finish();
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [dispatch, navigate]);

    return children;
}

export default AuthSessionRestore;
